import { render, staticRenderFns } from "./CommentOrderModal.vue?vue&type=template&id=382a9e36&scoped=true&"
import script from "./CommentOrderModal.vue?vue&type=script&lang=js&"
export * from "./CommentOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a9e36",
  null
  
)

export default component.exports